import {
  isNumber,
  isString,
  isUndefined,
  typeGuardGenerator,
  unionGuard,
} from '@metools/tcheck';

export const SnackBarTypeEnum = {
  Success: 'success',
  Error: 'error',
  Info: 'info',
};

/**
 * @param {unknown} input The input to check.
 * @returns {input is SnackBarTypeEnum} Whether the input is a valid Snackbar type.
 */
function isSnackBarTypeEnum(input) {
  return input === 'success' || input === 'error' || input === 'info';
}

/**
 * Options for configuring a Snackbar.
 * @typedef  {object} SnackbarOptions
 * @property {string} message - The message to display in the Snackbar.
 * @property {string} type - The type of the Snackbar.
 * @property {number} [duration] - The duration the Snackbar should be displayed (optional).
 */

/** @type {(input: unknown) => input is SnackbarOptions} */
export const isSnackbarOptions = typeGuardGenerator({
  message: isString,
  type: isSnackBarTypeEnum,
  duration: unionGuard(isUndefined, isNumber),
});
